// İçerik Stüdyosu — marka tohumları.
//
// Stüdyo marka bağımsız çalışır: sınırlar backend'de marka şemasında saklanıyor.
// Burası yalnızca "ilk açılışta ekranda ne yazsın" sorusunun cevabı. Bir marka
// profilini bir kez kaydettiğinde bu dosya o marka için devre dışı kalır.
//
// Europcar tohumu uydurma değil: sınırlar ve brief havuzu blog envanteri +
// kelime araştırması çalışmasından geliyor (bkz. europcarSeoPlan.js,
// /r/europcar-blog). Yeni bir marka eklemek = buraya bir kayıt yazmak, kod
// değişikliği gerekmiyor.

import { BLOG_BRIEFLERI } from '../europcarSeoPlan';

export const EUROPCAR_BRAND_ID = '13b58e06-8266-4a5b-8113-2de43aa686e1';

/* ────────────────────────── Europcar tohum profili ────────────────────────── */

// 2026-09-02 — Sınırlar artık tahmin değil ÖLÇÜM. Sitedeki 5 canlı TR yazı
// (ceza, ehliyet yaşı, ek sürücü, kredi kartsız kiralama, uzun dönem) HTML
// olarak çekilip yapıları sayıldı. Ölçülenler:
//
//   kelime .......... 1.112–1.320 gövde (envanterde 1.189–1.398)
//   H2 .............. 6–10 adet, H3 HİÇ YOK — düz tek seviye
//   soru biçimli H2 .. 9 başlığın 6–8'i soru ("… Ücretli mi?", "… Nasıl Öğrenilir?")
//   SSS bölümü ...... 5 yazının 5'inde de YOK, FAQPage şeması da yok
//   giriş ........... 5 yazının 5'inde de TAM 2 paragraf
//   paragraf ........ ortalama 2,0–3,3 cümle, en uzunu 7
//   cümle ........... ortalama 13,2–18,2 kelime
//   iç link ......... 2–3 adet, hepsi ana sayfaya, çapa "araç kiralama"/"rent a car"
//   marka adı ....... gövdede sadece 2 kez, o da son bölümde
//   son H2 .......... 5'in 4'ünde marka kapanış bölümü
//   liste/tablo ..... 5'te 1 yazıda (2 liste + 1 tablo); gerisi düz paragraf
//   meta ............ 132–145 karakter, emir kipiyle bitiyor
//   SEO başlığı ..... 44–54 karakter ve H1'DEN FARKLI (H1 tam soruyu kuruyor)
//   şema ............ Organization + WebSite + Article + BreadcrumbList (temadan)
//
// Kelime aralığı sitenin üst bandına yaslandı: yazı blogun ailesinden görünsün
// ama en dolgun örneği kadar olsun.
const EUROPCAR_PROFIL = {
  dil: 'tr',
  markaSesi:
    'Europcar Türkiye — araç kiralama. Anlatım net ve operasyonel: okuyucu bir işlemi ' +
    'yapmaya ya da bir kuralı anlamaya geliyor. Kurumsal ama mesafeli değil, ikinci ' +
    'çoğul şahıs ("kiralarken", "sözleşmenizde"). Reklam dili değil, prosedür dili. ' +
    'Marka adı gövdede kovalanmaz: yazı boyunca konuyu jenerik anlatır, "Europcar" ' +
    'yalnızca son bölümde geçer. "Rent a car" ifadesi Türkçe metinde doğal bir ' +
    'eşanlamlı olarak kullanılabilir, sitede de öyle kullanılıyor.',
  okuyucu:
    'Bireysel kiralayan (tatil, iş seyahati, geçici araç ihtiyacı) ve kurumsal/filo ' +
    'tarafında karar veren kişi. Çoğu ilk kez kiralamıyor ama kuralları tam bilmiyor; ' +
    'arama sorgularının büyük kısmı "şart", "sınır", "gerekli belge", "ceza" ekseninde.',
  ton: 'Bilgilendirici, sade, abartısız. Cümleler ortalama 15 kelime, hiçbiri 35 kelimeyi geçmesin. Soruyu ilk paragrafta cevapla, sonra detaylandır.',
  kelimeMin: 1200,
  kelimeMax: 1450,
  baslikMax: 60,
  metaMin: 130,
  metaMax: 150,
  h2Min: 7,
  h2Max: 10,
  paragrafMaxCumle: 5,
  yogunlukMin: 0.6,
  yogunlukMax: 2.5,
  // Sitede SSS bölümü ve FAQPage şeması yok; sorular SSS bloğuna değil soru
  // biçimli H2'lere gidiyor. Rakiplerin önüne geçmek için SSS istenirse burayı
  // 5 yapmak yeterli — o zaman yazı sitenin şablonundan ayrılır, bilerek.
  sssAdet: 0,
  icLinkMin: 2,
  cta:
    'Yazının SON H2\'si marka bölümü olsun: başlığı konuyla Europcar Türkiye\'yi ' +
    'birleştirsin ("… İçin Europcar Türkiye Yanınızda" kalıbı), altında 1-2 paragrafta ' +
    'geniş ofis ağı, filo ve şeffaf sözleşme üzerinden online rezervasyona davet etsin. ' +
    'Baskısız, rakam vermeden.',
  // Rakip adları burada: yasak listesi denetimde tek geçişte bile "kaldı" veriyor,
  // yani bir rakip adı metne sızarsa taslak yayına hazır görünmüyor.
  yasakIfadeler: [
    'Sixt', 'Avis', 'Hertz', 'Enterprise', 'Budget', 'Garenta', 'Cizgi', 'Çizgi Rental',
    'en ucuz', 'en uygun fiyat', 'garanti ediyoruz', 'kesinlikle', 'dünyanın en iyisi',
    'sektörün lideri', 'hemen şimdi', '—',
  ],
  zorunluIfadeler: [],
  kacinilacakKonular: [
    'Kesin fiyat, günlük ücret ya da kampanya tutarı yazma — fiyatlar dönemsel.',
    'Sigorta kapsamını "her şey dahil" gibi mutlak ifadelerle anlatma; kapsamı sözleşmeye bağla.',
    'Yasal bir yükümlülüğü tarih/madde numarasıyla iddia etme, doğrulanmadan yazma.',
    'H3 kullanma — sitedeki yazıların hiçbirinde alt başlık yok, hiyerarşi tek seviye.',
    'Sonda ayrı "Sıkça Sorulan Sorular" bölümü açma; soruları H2 olarak sor ve orada cevapla.',
  ],
  ekTalimat:
    'YAPI (sitedeki 5 yazıdan ölçüldü, birebir uy): ' +
    '(1) Giriş TAM 2 paragraf olsun. Birincisi konuyu kullanıcının durumundan kurar, ' +
    'ikincisi "Ancak…" ile asıl soruna döner ve yazının ne cevaplayacağını söyler. ' +
    '(2) 7-10 H2, H3 YOK. H2\'lerin en az üçte ikisi soru cümlesi olsun ' +
    '("Ek Sürücü Ücreti Zorunlu mu, Hangi Durumlarda Ücretsiz Olur?" gibi) — ' +
    'okuyucunun Google\'a yazdığı soru başlığa aynen taşınsın. ' +
    '(3) Her H2 altında 2-3 paragraf; paragraf 2-4 cümle. ' +
    '(4) Madde listesini ancak gerçekten sayılabilir bir şey varsa kur (şartlar, ' +
    'gerekli belgeler); yazıda en fazla bir liste olsun. Veri gerçekten tabloya ' +
    'sığıyorsa (segment/yaş/süre gibi) tek bir tablo kurulabilir, zorlama. ' +
    '(5) SEO başlığı (metaBaslik) H1\'den FARKLI ve daha kısa yazılsın: H1 tam soruyu ' +
    'kurar, metaBaslik 45-55 karakterde özetler. ' +
    '(6) Meta açıklama emir kipiyle bitsin ("… öğrenin.", "… hemen rezervasyon yapın."). ' +
    'DİL: Konu bir kural ya da sınırla ilgiliyse ("km sınırı", "ehliyet yaşı", ' +
    '"depozito", "ceza"), ilk H2 doğrudan cevabı versin; okuyucu aşağı kaydırmak ' +
    'zorunda kalmasın. Lokasyon geçirmen gerekirse şehir/havalimanı adını kullan, ' +
    'ofis adresi uydurma. Araç örneği vermen gerekirse segment adıyla yetin.',
};

/* ───────────────────────── Europcar brief havuzu ──────────────────────────── */

// europcarSeoPlan.js'teki 10 brief stüdyonun brief formuna çevriliyor. Orada
// analiz çıktısı, burada doldurulmaya hazır form. `kws` hacme göre sıralı geldiği
// için ilki odak kelime, kalanı yardımcı.
// Arama niyeti brief'te ayrı bir alan: prompt'a "Arama niyeti:" satırı olarak
// giriyor ve modelin yazıyı hangi anda okunacağına göre kurmasını sağlıyor.
// Kümelerin kelime listelerinden okundu, uydurulmadı — ör. 6 numarada kelimelerin
// tamamı "sorgulama"/"ödeme" fiiliyle geliyor, yani okuyucu ceza zaten gelmişken
// aratıyor; 5 numarada ise henüz kiralamamış, uygunluğunu kontrol ediyor.
const EUROPCAR_NIYET = {
  1: 'Rezervasyon öncesi doğrulama. Okuyucu uzun bir yol planlıyor ya da aşım ücreti duymuş; "hakkım kaç km, aşarsam ne öderim" sorusunun sayısal cevabını arıyor. İlk H2 doğrudan km hakkını versin.',
  2: 'Karşılaştırma / değerlendirme. Okuyucu henüz firma seçmemiş, neye bakacağını bilmiyor. Yazı bir kontrol listesi gibi kurulsun; firma adı geçirmeden, kriterleri sıralayarak.',
  3: 'Hizmet keşfi + maliyet. Kurumsal misafir karşılama, etkinlik ya da uzun transfer planlayan okuyucu; "bu hizmet bana mı uygun, fiyat neye göre değişiyor" diye bakıyor.',
  4: 'Seyahat öncesi hazırlık. Okuyucu yurt dışına gidiyor ve belge/ödeme engeline takılmak istemiyor: uluslararası ehliyet, kredi kartı, sigorta kapsamı.',
  5: 'Uygunluk kontrolü. Okuyucu genç ya da ehliyeti yeni; "beni kiralar mı, ek ücret öder miyim" diye bakıyor. Cevap ilk H2\'de net verilsin, sonra şartlar açılsın.',
  6: 'İşlem sonrası, aciliyet var. Ceza zaten gelmiş ya da geleceğinden şüpheleniliyor; okuyucu adım arıyor. Yazı "nasıl sorgulanır / nasıl ödenir" ekseninde kalsın, süreci baştan anlatan mevcut yazıya iç link verilsin.',
  7: 'Süre bazlı karşılaştırma. Okuyucu kaç aylık kiralamanın kendisine uygun olduğuna karar vermeye çalışıyor; kısa dönem ile uzun dönem arasındaki eşiği arıyor.',
  8: 'Planlama. Kalabalık bir grup ya da aile yolculuğu var; okuyucu kaç kişilik araç gerektiğini, bagaj ve otoyol geçiş sınıfını merak ediyor.',
  9: 'İş amaçlı araç seçimi. Taşıma, kurulum ya da saha işi için araç arıyor; hacim, yük kapasitesi ve kiralama şartları öne çıkıyor.',
  10: 'Fiyat ve şart merakı. Okuyucu üst segment bir araç istiyor ama depozito ve yaş/ehliyet şartından çekiniyor; maliyetin neden farklı olduğunu anlamak istiyor.',
};

export const EUROPCAR_BRIEFLERI = (BLOG_BRIEFLERI || []).map((b) => {
  const kws = Array.isArray(b.kws) ? b.kws : [];
  return {
    kaynak: 'Europcar SEO planı · 05.08.2026',
    no: b.no,
    baslik: b.baslik,
    kume: b.kume,
    hacim: b.hacim,
    bosluk: b.bosluk,
    odakKelime: kws[0]?.kw || '',
    yardimciKelimeler: kws.slice(1, 9).map((k) => k.kw),
    sorular: Array.isArray(b.sorular) ? b.sorular : [],
    aramaNiyeti: EUROPCAR_NIYET[b.no] || '',
    notlar: b.not || '',
  };
});

/* ─────────────────────────── Multinet tohum profili ───────────────────────── */

export const MULTINET_BRAND_ID = '7f97784c-d406-4400-830b-8d13a7c21d5f';

// 2026-09-22 — multinet.com.tr/blog'daki 10 yazının Markdown sürümü (her yazının
// `.md` adresi var) çekilip yapıları sayıldı: yemek kartı nedir, yemekhane mi
// yemek kartı mı, yan haklar, esnek yan haklar, yemek gideri muhasebesi, yakıt
// kartı, ramazan yardımı muhasebesi, babalık izni, bordro, tabldot. Ölçülenler:
//
//   kelime .......... 324–2.276; rehber türü yazılar (izin, bordro, muhasebe,
//                     yan haklar) 1.125–2.276, ürüne yakın kısa yazılar 550–790
//   H2 .............. çoğu 4–9 (en dolgun yazıda 21); H3 10 yazının 4'ünde var,
//                     alt soruları taşıyor ("Babalık İzni Uzatılabilir mi?")
//   giriş ........... 1–2 paragraf
//   paragraf ........ en fazla 5 cümle; cümle ortalaması 12–16 kelime
//   liste ........... 10 yazının 8'inde madde listesi; tablo hiç yok
//   SSS bölümü ...... hiçbirinde yok
//   iç link ......... 3–27, çoğu 6–19; blog yazıları + ürün sayfaları
//                     (/gunluk-yemek-bedeli-istisnasi, /multinet-yemek-karti,
//                     /multinet-vergi-hesaplama, /multigift-hediye-karti,
//                     /kart-kullanim-noktalari)
//   marka ........... gövdede sık (5–33 kez); 10 yazının 7'sinde SON H2 bir ürün
//                     başlığı ("MultiGift Kurumsal Hediye Kartı ile Çalışanlarınızı
//                     Kutlayın", "Multinet Up Hizmetleri ile … Sağlayın!")
//   mevzuat ......... kanun adı + sayısıyla atıf yapılıyor (4857, 213, 5510),
//                     yıl etiketi başlıkta ("[2026]")
//   meta ............ 96–153 karakter, "bu yazımızda!" / "hemen tıklayın!" kalıbı
//   SEO başlığı ..... 32–65 karakter, " | Multinet Up" ekiyle
const MULTINET_PROFIL = {
  dil: 'tr',
  markaSesi:
    'Multinet Up — yemek kartı (MultiNet), hediye kartı (MultiGift), yakıt kartı ' +
    '(MultiPetrol), esnek yan haklar (MultiFlex) ve MultiPay uygulaması. Kurum adı ' +
    '"Multinet Up", ürün adları büyük harf ortadan: MultiNet, MultiGift, MultiPay. ' +
    'Anlatım bilgilendirici ve çözüm odaklı: önce konuyu jenerik ve mevzuata dayalı ' +
    'anlatır, sonra işverenin ya da çalışanın bunu nasıl kolaylaştırabileceğini ' +
    'Multinet Up ürünüyle bağlar. Hitap ikinci çoğul şahıs ("çalışanlarınıza", ' +
    '"işletmeniz"). Samimi ama kurumsal; ünlem yalnızca kapanışta.',
  okuyucu:
    'İki ana okur: (1) İşveren tarafı — İK, bordro ve muhasebe sorumlusu, küçük ' +
    'işletme sahibi; vergi avantajı, zorunluluk ve maliyet soruyor. (2) Kart ' +
    'kullanıcısı çalışan — bakiyenin nerede geçtiğini, nakde çevrilip ' +
    'çevrilemeyeceğini, işten ayrılınca ne olacağını soruyor. Üçüncü ve küçük okur ' +
    'üye işyeri: restoran ya da market sahibi.',
  ton: 'Bilgilendirici, sade, güven veren. Cümleler ortalama 13-15 kelime, hiçbiri 35 kelimeyi geçmesin. Soruyu ilk H2\'de cevapla, sonra ayrıntıya in.',
  kelimeMin: 1000,
  kelimeMax: 1500,
  baslikMax: 60,
  metaMin: 120,
  metaMax: 155,
  h2Min: 5,
  h2Max: 9,
  paragrafMaxCumle: 5,
  yogunlukMin: 0.6,
  yogunlukMax: 2.5,
  // Blogda SSS bölümü yok; sorular H2/H3 olarak soruluyor.
  sssAdet: 0,
  icLinkMin: 4,
  cta:
    'Yazının SON H2\'si ürün bölümü olsun ve başlıkta ürün adı geçsin ("MultiNet ' +
    'Yemek Kartı ile …", "MultiGift ile …" kalıbı). Altında 1-2 paragrafta konuyu ' +
    'ürünün sağladığı kolaylığa bağla ve ilgili ürün sayfasına iç link ver. ' +
    'Rakam iddiası (nokta sayısı, tasarruf tutarı) yalnızca brief\'teki olgularda ' +
    'varsa yazılsın.',
  // Rakip adları: yasak listesi denetimde tek geçişte "kaldı" veriyor.
  yasakIfadeler: [
    'Pluxee', 'Sodexo', 'Edenred', 'Ticket', 'Setcard', 'SetCard', 'Metropol', 'MetropolCard',
    'TokenFlex', 'Token Flex',
    'en ucuz', 'garanti ediyoruz', 'kesinlikle', 'sektörün lideri', 'pazar lideri',
    'bir numaralı', '—',
  ],
  zorunluIfadeler: [],
  kacinilacakKonular: [
    'Güncel tutar (yemek bedeli istisnası, asgari ücret, SGK oranı) yazacaksan yalnızca brief\'teki olgulardan al; olgu yoksa tutar yazma, "her yıl Resmî Gazete\'de ilan edilir" de.',
    'Kanun maddesi ya da tebliğ numarası uydurma; atıf yapacaksan brief\'teki olgulardaki numarayı kullan.',
    'Yemek kartı bakiyesini nakde çevirmenin yolunu tarif etme, üstü kapalı da olsa önerme.',
    'Rakip firma adı geçirme; karşılaştırma gerekiyorsa kriter üzerinden anlat.',
    'Üye işyeri komisyon oranı için rakam verme; oran sözleşmeye bağlıdır.',
  ],
  ekTalimat:
    'YAPI (bloğun 10 yazısından ölçüldü): ' +
    '(1) Giriş 1-2 paragraf: okurun durumunu kur, yazının neyi cevaplayacağını söyle. ' +
    '(2) 5-9 H2. Alt soru varsa H3 kullan (ör. "… Uzatılabilir mi?"); bir H2 altında en fazla 6 H3. ' +
    'H2\'lerin çoğu soru cümlesi olsun, okurun Google\'a yazdığı soru başlığa taşınsın. ' +
    '(3) Paragraf 2-4 cümle. Sayılabilir şeyleri (şartlar, adımlar, avantajlar) madde listesiyle ver; ' +
    'yazıda 1-3 liste olabilir, tablo kurma. ' +
    '(4) İç link: ilgili blog yazılarına ve ürün sayfalarına en az 4 bağlantı ' +
    '(/gunluk-yemek-bedeli-istisnasi, /multinet-yemek-karti, /multinet-vergi-hesaplama, ' +
    '/multigift-hediye-karti, /kart-kullanim-noktalari, /multinet-uye-isyeri). ' +
    '(5) Mevzuat konusunda başlığa yıl etiketi ekle ("… [2026]"). ' +
    '(6) SEO başlığı (metaBaslik) 45-60 karakter, " | Multinet Up" ile bitsin. ' +
    '(7) Meta açıklama 120-155 karakter, "bu yazımızda!" ya da "hemen inceleyin!" gibi davetle bitsin.',
};

/* ───────────────────────── Multinet brief havuzu ──────────────────────────── */

// Kaynaklar (22 Eyl 2026):
//  - Hacim: Google Ads Keyword Planner, TR + Türkçe, Eyl 2025 – Ağu 2026 aylık
//    ortalaması. Tohum: "yemek kartı", "yemek bedeli istisnası", "yan haklar",
//    "hediye kartı", "yakıt kartı" fikirleri + 55 aday sorgu toplu ölçüm.
//    `hacim` = brief'teki odak + yardımcı kelimelerin aylık ortalamalarının
//    toplamı; bir kelime yalnızca bir brief'te sayıldı.
//  - Boşluk: multinet.com.tr/sitemap.xml (~440 blog adresi + ürün sayfaları).
//    Karşılığı olan konular havuza ALINMADI: yemek istisnası 2026 (açılış sayfası
//    /gunluk-yemek-bedeli-istisnasi güncel, 330 TL), tabldot, catering, taşıt
//    tanıma, yan haklar nelerdir, "multinet geçen yerler" (marka araması, ürün sayfası).
//  - Niyet sinyali: AI Visibility sorular (MNT-xxx) ve MultiPay yorum analizi
//    (/market-insights/multipay-yorum-analizi).
export const MULTINET_BRIEFLERI = [
  {
    no: 1,
    baslik: 'Yemek Kartı Nakite Çevrilir mi? Bakiyeyi Değerlendirmenin Yasal Yolları',
    kume: 'Kart kullanıcısı · bakiye',
    hacim: 1058,
    bosluk: 'Sitede karşılığı yok. /nakit-mi-yemek-karti-mi işverenin seçimini anlatıyor, çalışanın sorusunu değil. MultiPay yorumlarında "nakde çevrilmiyor, para kartta kalıyor" şikâyeti tekrar ediyor.',
    odakKelime: 'yemek kartı nakite çevirme',
    yardimciKelimeler: ['yemek kartı nerelerde geçer'],
    sorular: [
      'Yemek kartı bakiyesi nakde çevrilebilir mi?',
      'Yemek kartını nakde çevirmek neden kurallara aykırı, yaptırımı var mı?',
      'Harcanmayan yemek kartı bakiyesi ne olur?',
      'Bakiyeyi nerelerde kullanabilirim (restoran, market, online sipariş)?',
      'Bakiyemi nasıl sorgularım?',
    ],
    aramaNiyeti: 'Kart kullanıcısı bakiyesini harcayamıyor ya da nakde ihtiyacı var; "kartı bozdurabilir miyim" diye arıyor. Yazı cevabı ilk H2\'de net versin (kurallar izin vermez ve neden), sonra bakiyeyi yasal olarak değerlendirmenin yollarına geçsin. Nakde çevirmenin yöntemini asla tarif etmesin.',
    notlar: 'Son H2: MultiPay ile bakiye ve geçerli noktaları görme; /kart-kullanim-noktalari linki.',
  },
  {
    no: 2,
    baslik: 'İşveren Yemek Vermek Zorunda mı? Yemek Yardımı ve Yasal Çerçeve [2026]',
    kume: 'İşveren · mevzuat',
    hacim: 474,
    bosluk: 'Blogda ayrı yazı yok. "Yan haklar" yazısında "Çalışanlara Yol ve Yemek Ücreti Sunmak Zorunlu mu?" H2\'si var; bu yazı o soruyu derinleştirsin, oraya link versin, yamyamlık yapmasın.',
    odakKelime: 'işveren yemek vermek zorunda mı',
    yardimciKelimeler: ['yemek yardımı', 'sgk yemek istisnası', 'yemek kartı zorunlu mu', 'yemek ücreti sgk'],
    sorular: [
      'İşveren çalışanına yemek vermek zorunda mı?',
      'Yemek yardımı hangi durumlarda zorunlu hâle gelir (iş sözleşmesi, toplu sözleşme, işyeri uygulaması)?',
      'Yemek yardımı nakit, yemekhane ya da yemek kartıyla verilebilir mi?',
      'Yemek yardımının vergi ve SGK karşısındaki durumu nedir?',
      'Uzaktan çalışana yemek yardımı kesilebilir mi?',
    ],
    aramaNiyeti: 'Çalışan hakkını, küçük işveren yükümlülüğünü soruyor. İlk H2 doğrudan cevap versin; sonra zorunluluğun doğduğu durumlar ve yemek yardımının biçimleri. Mevzuat atıfları yalnızca olgulardan.',
    notlar: 'Olgular alanına 2026 istisna tutarı (330 TL, 31.12.2025 tarihli 33124 sayılı RG — /gunluk-yemek-bedeli-istisnasi sayfasından) eklenmeli. Son H2: MultiNet Yemek Kartı.',
  },
  {
    no: 3,
    baslik: 'Yemek Kartı Firması Seçerken Nelere Bakılmalı? 8 Kriter',
    kume: 'İşveren · karşılaştırma',
    hacim: 980,
    bosluk: 'Blogda yok. Arama "yemek kartı firmaları", "en çok kullanılan yemek kartları", "en iyi yemek kartı" ekseninde; AI Visibility\'de MNT-002, MNT-006, MNT-012 aynı niyeti soruyor.',
    odakKelime: 'yemek kartı firmaları',
    yardimciKelimeler: ['yemek kart firmaları', 'en çok kullanılan yemek kartları', 'en iyi yemek kartı', 'en avantajlı yemek kartı', 'şirket yemek kartları', 'yemek kartı veren firmalar', 'yemek kartları karşılaştırma'],
    sorular: [
      'Yemek kartı firmaları arasında seçim yaparken hangi kriterlere bakılmalı?',
      'Geçerli nokta sayısı ve market / online sipariş kabulü neden önemli?',
      'Mobil uygulamanın kararlılığı ve ödeme yöntemleri (QR, NFC) nasıl değerlendirilir?',
      'Küçük bir şirket için yemek kartı seçerken nelere dikkat edilmeli?',
      'Yemek kartına geçiş süreci nasıl işler?',
    ],
    aramaNiyeti: 'İK ya da satın alma, henüz firma seçmemiş. Yazı kontrol listesi gibi kurulsun; FİRMA ADI GEÇMESİN, kriterler sıralansın. Her kriter için "neden önemli / nasıl sorulur" verilsin.',
    notlar: 'Kriter önerisi — kullanıcı yorumlarından (App Radar) çıkan gerçek sorunlar: ödeme anında uygulamanın çalışması, işyeri listesinin doğruluğu, destek erişimi. Son H2: MultiNet Yemek Kartı.',
  },
  {
    no: 4,
    baslik: 'Yemek Kartı Markette Geçer mi? Market Alışverişinde Kurallar',
    kume: 'Kart kullanıcısı · market',
    hacim: 422,
    bosluk: '/multinet-yemek-karti-gecen-marketler markaya özel liste sayfası; "yemek kartıyla market alışverişi yapılır mı" sorusunu cevaplayan genel yazı yok. Yazı o sayfaya link verip listeyi tekrar etmesin.',
    odakKelime: 'yemek kartları market alışverişi',
    yardimciKelimeler: ['yemek kartı market', 'yemek kartları market', 'yemek kartı ile market alışverişi', 'multinet market'],
    sorular: [
      'Yemek kartı ile market alışverişi yapılabilir mi?',
      'Markette yemek kartıyla hangi ürünler alınabilir, hangileri alınamaz?',
      'Neden bazı marketler yemek kartı kabul etmiyor?',
      'Yemek kartının geçtiği marketler nasıl bulunur?',
    ],
    aramaNiyeti: 'Kart kullanıcısı bakiyesini markette harcamak istiyor, kuralı ve geçen yerleri arıyor. İlk H2 kısa ve net cevap versin; ürün kısıtları (ör. alkol, tütün) ve kabul eden market bulma adımları gelsin.',
    notlar: 'Market kabulüne dair güncel düzenleme varsa olgulara eklenmeli; yoksa kural iddiası yapılmasın. MultiPay yorumlarında zincir marketlerde geçmeme şikâyeti yoğun.',
  },
  {
    no: 5,
    baslik: 'Restoranlar İçin Yemek Kartı: Üye İşyeri Olmak ve Komisyon Nasıl İşler?',
    kume: 'Üye işyeri',
    hacim: 133,
    bosluk: 'Blogda işyeri tarafına yazılmış yazı yok; /multinet-uye-isyeri ürün sayfası. AI Visibility\'de MNT-007 ve MNT-008 aynı soruyu soruyor.',
    odakKelime: 'yemek kartı komisyon oranları',
    yardimciKelimeler: ['yemek kartı üye işyeri'],
    sorular: [
      'Yemek kartı kabul etmek restorana ne kazandırır?',
      'Üye işyeri olmak için hangi adımlar izlenir?',
      'Yemek kartı komisyonu neye göre belirlenir, ödeme ne zaman hesaba geçer?',
      'Hangi POS ve ödeme yöntemleri (QR, NFC, fiziki kart) gerekir?',
    ],
    aramaNiyeti: 'Restoran / kafe / market sahibi yemek kartı kabul etmeyi tartıyor. Yazı işletme sahibinin gözünden kurulsun: kazanç, süreç, maliyet kalemleri. Komisyon ORANI yazılmasın.',
    notlar: 'Son H2: Multinet Up üye işyeri; /multinet-uye-isyeri linki.',
  },
  {
    no: 6,
    baslik: 'Şirketler İçin Yemek Kartı Nasıl Alınır? Başvuru Adımları',
    kume: 'İşveren · satın alma',
    hacim: 267,
    bosluk: 'Blogda yok; /multinet-yemek-karti ürün sayfası süreci anlatmıyor. MNT-012 (20 çalışanlı şirket) aynı niyet.',
    odakKelime: 'yemek kartı başvurusu',
    yardimciKelimeler: ['yemek kartı nasıl alınır', 'işyeri yemek kartı', 'bireysel yemek kartı'],
    sorular: [
      'Şirketler yemek kartına nasıl başvurur, hangi belgeler gerekir?',
      'Bakiye yükleme nasıl ve ne sıklıkla yapılır?',
      'Kartlar çalışanlara nasıl ulaşır, dijital kart mümkün mü?',
      'Bireysel olarak yemek kartı alınabilir mi?',
      'Küçük işletmeler yemek kartından yararlanabilir mi?',
    ],
    aramaNiyeti: 'Küçük / orta işveren karar vermiş, süreci öğrenmek istiyor. Yazı adım adım kurulsun (numaralı liste), her adıma kısa açıklama.',
    notlar: '"Bireysel yemek kartı" aranıyor: yemek kartının işveren üzerinden verildiği net söylenmeli. Son H2: MultiNet Yemek Kartı + /multinet-vergi-hesaplama.',
  },
  {
    no: 7,
    baslik: 'Yemek Fişi, Yemek Çeki ve Yemek Kartı: Farkları Neler?',
    kume: 'Genel · terim',
    hacim: 546,
    bosluk: '/multinet-yemek-fisi ve /multinet-yemek-ceki ürün sayfaları; üçünü karşılaştıran bilgilendirici yazı yok.',
    odakKelime: 'yemek fişi',
    yardimciKelimeler: ['yemek çeki', 'yemek çeki firmaları'],
    sorular: [
      'Yemek fişi nedir, bugün hâlâ kullanılıyor mu?',
      'Yemek çeki ile yemek kartı arasındaki fark nedir?',
      'Kâğıt yemek fişinden karta geçiş işverene ne kazandırdı?',
      'Vergi avantajı açısından yemek fişi ve yemek kartı aynı mı?',
    ],
    aramaNiyeti: 'Eski terimi arayan okur (çoğunlukla "yemek fişi" diye soruyor). Yazı terimleri tanımlasın, farkları bir kıyasla versin, bugünkü karşılığını göstersin.',
    notlar: '"Yemek kartı nedir" yazısıyla yamyamlık yapmasın; tanımı kısa geçip oraya link versin. Son H2: MultiNet Yemek Kartı.',
  },
  {
    no: 8,
    baslik: 'Çalışanlara Hediye Çeki Vermek: Vergi ve Muhasebe Kaydı',
    kume: 'İşveren · hediye',
    hacim: 205,
    bosluk: 'Ramazan yardımı muhasebesi yazısında alt başlık olarak geçiyor; genel bir hediye çeki vergi / muhasebe yazısı yok. /multigift-vergi-hesaplama aracı var.',
    odakKelime: 'hediye çeki muhasebe kaydı',
    yardimciKelimeler: ['kurumsal hediye kartı', 'kurumsal hediye çeki'],
    sorular: [
      'Çalışana verilen hediye çeki gelir vergisine tabi mi?',
      'Hediye çeki SGK primine dahil edilir mi?',
      'Hediye çeki muhasebe kaydı nasıl yapılır?',
      'Bayram, doğum, yılbaşı gibi özel günlerde hediye çeki vermenin kuralları neler?',
    ],
    aramaNiyeti: 'Muhasebe / bordro sorumlusu; kaydı doğru yapmak ve vergi yükünü bilmek istiyor. Yazı mevzuata dayalı, adım adım; ramazan yazısına link versin.',
    notlar: 'Vergi / SGK oranları yalnızca olgulardan. Son H2: MultiGift + /multigift-vergi-hesaplama.',
  },
  {
    no: 9,
    baslik: 'İşten Ayrılınca Yemek Kartı Bakiyesi Ne Olur? Yanar mı, Devreder mi?',
    kume: 'Kart kullanıcısı · bakiye',
    hacim: null,
    bosluk: 'Keyword Planner bu sorgular için hacim döndürmedi ("bakiyesi yanar mı", "devir", "son kullanma tarihi"). Konu MultiPay yorumlarından geliyor: işten ayrılınca bakiyeye bloke konmasına dair tekrar eden 1★ yorumlar var. Sitede karşılığı yok.',
    odakKelime: 'yemek kartı bakiyesi',
    yardimciKelimeler: [],
    sorular: [
      'İşten ayrılınca yemek kartındaki bakiye ne olur?',
      'Yemek kartı bakiyesinin son kullanma tarihi var mı?',
      'Kalan bakiye yeni işverene ya da başka karta aktarılabilir mi?',
      'Kart kaybolursa bakiye nasıl korunur?',
    ],
    aramaNiyeti: 'Çalışan işten ayrılıyor ya da ayrılmış; parasını kaybetmekten korkuyor. Yazı güven versin: kural ne, işveren ile kart firmasının rolü ne, kullanıcı ne yapmalı.',
    notlar: 'Bakiye iadesi / blokaj kuralları firmaya ve sözleşmeye göre değişir; Multinet Up\'ın kendi kuralı olgulara eklenmeden kesin hüküm yazılmasın.',
  },
];

/* ─────────────────────────────── Baqa ──────────────────────────────────── */

export const BAQA_BRAND_ID = '67b7c414-1e1c-4823-a952-12f3cfee5369';

// 2026-09-24 — baqaofficial.com/blogs/news atom akışındaki son 30 yazı sayıldı:
//
//   kelime .......... 153–808, medyan ~500; son altı ayın yazıları 400–800
//   H2 .............. Eylül 2026 yazılarında 3–14, Haziran öncesinde çoğunda 0;
//                     H3 yalnızca eski kısa yazılarda
//   iç link ......... medyan 1; 30 yazının 7'sinde hiç ürün/koleksiyon linki yok
//   SSS ............. hiçbirinde yok
//   dil ............. "zamansız", "sessiz şıklık", "silüet", "doku", İstanbul
//                     göndermesi; ikinci tekil hitap ("gardırobunuza" çoğul da var)
//   künye ........... 29/30 yazıda yazar "BAQA ." — yazının kendisi etkilemiyor
//
// Profil blogun sesini koruyor ama SEO için uzunluğu ve iç linki yukarı çekiyor:
// Search Console'da blog 12 ayda 242 tık aldı ve hiçbir organik satış blogdan
// başlamadı (bkz. /r/baqa-seo). Yazı ürüne bağlanmalı.
const BAQA_PROFIL = {
  dil: 'tr',
  markaSesi:
    'BAQA — İstanbul\'dan ilham alan premium kadın giyim markası. Doğal ve işçilikli ' +
    'kumaşlar (yün, kaşmir, keten, ipek, kupro), naturel renkler, hacimli formlar, ' +
    'yumuşak tuşeler. Marka adı her zaman büyük harfle: BAQA. Anlatım sakin ve ' +
    'özenli; gösterişten değil malzemeden ve kesimden söz eder. Blogun kendi ' +
    'kelimeleri: zamansız, sessiz şıklık, silüet, doku, katman.',
  okuyucu:
    '30-55 yaş, şehirli, çalışan ya da sosyal hayatı yoğun kadın. Parça başına ' +
    '15-50 bin TL harcamaya hazır; hızlı modaya değil uzun giyilecek parçaya ' +
    'bakıyor. Kumaşın ne olduğunu, nasıl eskiyeceğini, neyle giyileceğini soruyor.',
  ton: 'Zarif, bilgili, sakin. Cümleler ortalama 14-17 kelime, hiçbiri 32 kelimeyi geçmesin. Satış dili değil stil danışmanı dili; ünlem yok.',
  kelimeMin: 900,
  kelimeMax: 1400,
  baslikMax: 60,
  metaMin: 120,
  metaMax: 155,
  h2Min: 5,
  h2Max: 8,
  paragrafMaxCumle: 4,
  yogunlukMin: 0.6,
  yogunlukMax: 2.2,
  sssAdet: 3,
  icLinkMin: 5,
  cta:
    'Son H2 BAQA seçkisine ayrılsın ("BAQA … Seçkisinden" kalıbı). Altında yazıda ' +
    'anılan kesimlere karşılık gelen 3-5 ürüne ve ilgili koleksiyona iç link ver. ' +
    'Fiyat, kumaş oranı ya da ürün adı yalnızca brief\'teki notlarda varsa yazılsın.',
  yasakIfadeler: [
    'Vakko', 'Beymen', 'Machka', 'İpekyol', 'Gizia', 'Network', 'Yargıcı', 'Zara', 'Mango',
    'ucuz', 'uygun fiyatlı', 'indirim', 'kaçırmayın', 'hemen al', 'en iyi', 'bir numaralı',
    'lüks', '—',
  ],
  zorunluIfadeler: ['BAQA'],
  kacinilacakKonular: [
    'Kumaş oranı (yüzde yün, kaşmir) yalnızca brief notlarındaki ürün bilgisinden yazılsın; uydurma.',
    'Sıcak tutma derecesi, dayanıklılık yılı gibi ölçülmemiş iddia kurma.',
    'Rakip marka ya da "muadil" karşılaştırması yapma.',
    'İndirim, kampanya, stok aciliyeti dili kullanma.',
  ],
  ekTalimat:
    'YAPI: ' +
    '(1) Giriş 1-2 paragraf: mevsimi ve okurun sorusunu kur, yazının neyi cevaplayacağını söyle. ' +
    '(2) 5-8 H2, çoğu okurun Google\'a yazdığı soru ya da seçim ölçütü ("Kaşe Kaban Nedir?", ' +
    '"Uzun mu Kısa mı?"). Kesim ve model anlatan H2\'lerde H3 kullanılabilir. ' +
    '(3) Paragraf 2-4 cümle; ölçütleri madde listesiyle ver, en fazla 2 liste. ' +
    '(4) İç link: /collections/kaban, /collections/dis-giyim ve ürün sayfaları; en az 5. ' +
    'Ürün linkini ürün adıyla ver, "tıklayın" yazma. ' +
    '(5) Sonda 3 soruluk kısa SSS. ' +
    '(6) SEO başlığı (metaBaslik) 45-60 karakter, " | BAQA" ile bitsin. ' +
    '(7) Meta açıklama 120-155 karakter, davet cümlesi sakin olsun ("… keşfedin").',
};

// Kaynaklar (24 Eyl 2026, /r/baqa-seo hazırlığı):
//  - Hacim: Google Ads Keyword Planner, TR + Türkçe. `hacim` = odak + yardımcı
//    kelimelerin aylık ortalaması toplamı (odak: Eyl 2025-Ağu 2026 ortalaması;
//    yardımcılar KP fikir listesindeki 12 aylık ortalama). Kova tahmini.
//  - Konum: Search Console, son 12 ay.
//  - Ürünler: baqaofficial.com/products.json, 24 Eyl.
export const BAQA_BRIEFLERI = [
  {
    no: 1,
    baslik: 'Kaşe Kaban Nasıl Seçilir? Kadın Kaşe Kaban Modelleri ve Kombin Rehberi',
    kume: 'Dış giyim · kaban',
    hacim: 31950,
    bosluk:
      'Sitede 16 kaşe kaban var ama bunu anlatan yazı yok. Tek kaban yazısı ' +
      '"Zamansız Bir Şıklığın İfadesi: BAQA Kabanları" (Ekim 2025) 196 kelime, 12 ayda 199 ' +
      'gösterim ve 1 tık aldı; adresinde görünmez nokta karakteri var. Yeni yazı o yazıyı ' +
      'kapsasın; eskisi yayından kalkınca yenisine 301 ile yönlendirilsin. /collections/kaban ' +
      'Search Console\'da ortalama 10,7. sırada; "kaban" 17,3, "yün kaban" 14,8, "kaşmir kaban" ' +
      '11,6. sırada. "kaşe kaban kadın" Kasım\'da zirve yapıyor (27.650/ay): yazı Ekim ' +
      'ortasına kadar yayında olmalı.',
    odakKelime: 'kaşe kaban kadın',
    yardimciKelimeler: [
      'kaşe kaban', 'kadın kaşe kaban', 'kaşe kaban modelleri', 'uzun kaban kadın',
      'yün kaban kadın', 'kaşmir kaban',
    ],
    sorular: [
      'Kaşe kaban nedir, yün kabandan ve kaşmir kabandan farkı ne?',
      'Kaşe kaban seçerken kumaşta, astarda ve dikişte nelere bakılmalı?',
      'Uzun kaşe kaban mı kısa kaşe kaban mı: boya ve kullanıma göre nasıl seçilir?',
      'Kruvaze, şal yaka, dik yaka ve reglan kol: hangi kesim kime yakışır?',
      'Kaşe kaban altına ne giyilir? Ofis, hafta sonu ve akşam kombinleri',
      'Kaşe kaban nasıl temizlenir ve saklanır?',
    ],
    aramaNiyeti:
      'Kış öncesi kaban almayı düşünen, fiyat değil kalite ve kesim arayan kadın. ' +
      '"Kaşe kaban" diye aratıyor ama kaşenin ne olduğunu, uzun mu kısa mı almak ' +
      'gerektiğini tam bilmiyor. Yazı önce tanımı ve seçim ölçütlerini versin, sonra ' +
      'kesimleri ve kombinleri; en sonda BAQA seçkisine bağlansın.',
    notlar:
      'Son H2: "BAQA Kaşe Kaban Seçkisinden". Linklenecek ürünler (products.json, 24 Eyl): ' +
      'Şal Detaylı Uzun Kaşe Kaban (/products/sal-detayli-uzun-kase-kaban), ' +
      'Kruvaze Yaka Uzun Kaşe Kaban (/products/kruvaze-yaka-uzun-kase-kaban), ' +
      'Reglan Kollu Kaşe Kaban (/products/reglan-kol-kase-kaban), ' +
      'Dik Yaka Fermuarlı Kısa Kaşe Kaban (/products/dik-yaka-fermuarli-kisa-kase-kaban), ' +
      'Şal Yaka Kaşe Kaban (/products/sal-yaka-kase-kaban), ' +
      'Kruvaze Yaka Kaşmir Kaban (/products/kruvaze-yaka-kasmir-kaban-beyaz). ' +
      'Koleksiyon: /collections/kaban. Ürün açıklamalarında "Sonbahar/Kış 2027 dış giyim ' +
      'seçkisi" deniyor. Kumaş oranı ürün sayfasındaki "Kumaş İçeriği" tablosundan ' +
      'teyit edilmeden yazılmasın. Fiyat yazma.',
  },
];

/* ──────────────────────────────── kayıt ──────────────────────────────────── */

export const TOHUMLAR = {
  [EUROPCAR_BRAND_ID]: {
    ad: 'Europcar',
    profil: EUROPCAR_PROFIL,
    briefler: EUROPCAR_BRIEFLERI,
    kaynakSayfa: { yol: '/r/europcar-blog', ad: 'Blog Envanteri' },
  },
  [MULTINET_BRAND_ID]: {
    ad: 'Multinet',
    profil: MULTINET_PROFIL,
    briefler: MULTINET_BRIEFLERI,
    kaynakSayfa: { yol: '/market-insights/multipay-yorum-analizi', ad: 'MultiPay Yorum Analizi' },
  },
  [BAQA_BRAND_ID]: {
    ad: 'BAQA',
    profil: BAQA_PROFIL,
    briefler: BAQA_BRIEFLERI,
    kaynakSayfa: { yol: '/r/baqa-seo', ad: 'SEO sunumu' },
  },
};

export const tohumBul = (brandId) => TOHUMLAR[brandId] || null;
